exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width: 768px) {\n  .email-input {\n    width: 90%;\n    min-width: 200px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/form-elements/email-element-folder/email-element.scss
// module id = 1258
// module chunks = 0